<!--  -->
<template>
  <div class="dsawr">
    <div class="search_box">
      <div>
        <el-input v-model="pageIfon.ofword" style="width:200px;margin-right:10px" placeholder="请输入公众号搜索关键字" />
        <el-input v-model="pageIfon.mpword" style="width:200px;margin-right:10px" placeholder="请输入小程序搜索关键字" />
        <el-select v-model="pageIfon.onlyMe" placeholder="请选择" style="margin-right:10px">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select v-model="pageIfon.status" placeholder="请选择" style="margin-right:10px">
          <el-option
            v-for="item in statusarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
      <div>
        <el-button type="primary" icon="el-icon-thumb" style="margin-bottom:10px" @click="pijie">批量解绑</el-button>
        <el-button type="warning" icon="el-icon-thumb" style="margin-bottom:10px" @click="exportexcle">导出</el-button>
        <el-button type="success" icon="el-icon-plus" style="margin-bottom:10px" @click="bandwechatar">绑定小程序</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="Id"
        width="80"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="公众号appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="miniprogram_app_id"
        label="小程序appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="bindStatusText"
        label="绑定状态"
        width="190"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.bind_status == 1" class="el-icon-success defaultr" />
          <i v-if="scope.row.bind_status == 2" class="el-icon-more defaultrse" />
          <i v-if="scope.row.bind_status == 3" class="el-icon-error stopew" />
          <i v-if="scope.row.bind_status == 12" class="el-icon-more defaultrse" />
          <i v-if="scope.row.bind_status == 20" class="el-icon-warning" />
          <i v-if="scope.row.bind_status == 21" class="el-icon-success defaultrse" />
          <i v-if="scope.row.bind_status == 22" class="el-icon-more defaultrse" />
          <i v-if="scope.row.bind_status == 8" class="el-icon-more defaultrse" />
          {{ scope.row.bindStatusText }}
        </template>
      </el-table-column>
      <el-table-column
        prop="statusText"
        label="状态"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.status == 1" class="el-icon-warning defaultrse" />
          <i v-if="scope.row.status == 2" class="el-icon-warning defaultr" />
          <i v-if="scope.row.status == 3" class="el-icon-success defaultrse" />
          <i v-if="scope.row.status == 4" class="el-icon-error stopew" />
          <i v-if="scope.row.status == 5" class="el-icon-more defaultrse" />
          <i v-if="scope.row.status == 8" class="el-icon-warning stopew" />
          {{ scope.row.statusText }}
        </template>
      </el-table-column>
      <el-table-column
        prop="appIdName"
        label="公众号名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="miniProgramAppIdName"
        label="小程序名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="createdAtText"
        label="创建时间"
        width="180"
        align="center"
      />
      <el-table-column
        prop="createdAtText"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row.bind_status == 1" size="mini" type="danger" @click="unbind(scope.row)">解绑</el-button>
          <el-button v-if="scope.row.bind_status == 20" size="mini" type="warning" @click="refresh(scope.row)">刷新</el-button>
          <el-button v-if="scope.row.bind_status == 1" size="mini" type="warning" @click="refresh(scope.row)">刷新</el-button>
          <el-button v-if="scope.row.bind_status == 5" size="mini" type="warning" @click="refresh(scope.row)">刷新</el-button>
          <el-button v-if="scope.row.bind_status == 22" size="mini" type="warning" @click="refresh(scope.row)">刷新</el-button>
          <el-button v-if="scope.row.status == 8" size="mini" type="success" @click="restore(scope.row)">恢复使用</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="绑定小程序"
      :visible.sync="dialogVisible"
      width="40%"
      :destroy-on-close="true"
      @close="closewechat"
    >
      <div class="strate_box">
        <div>选择公众号：</div>
        <div style="width:90%">
          <el-tag
            v-for="itemr,index in arrs"
            :key="index"
            style="margin-right:10px;margin-bottom:5px;"
            closable
            :type="itemr.type"
            @close="rightclick(itemr.id,index)"
          >
            {{ itemr.name }}
          </el-tag>
          <el-tag @click="chooseaccout">选择公众号</el-tag>
        </div>
      </div>
      <div class="strate_box">
        <div>选择小程序：</div>
        <div style="width:90%">
          <el-tag v-if="wechatid">{{ wechatname }}</el-tag>
          <el-tag @click="choosewecaht">选择小程序</el-tag>
        </div>
      </div>
      <div style="color:#ccc">
        不选中小程序则默认拉取已经绑定的小程序到列表中
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureonclick">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择绑定的公众号"
      :visible.sync="dialogVisibler"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="50%"
    >
      <ChooseaccountDialog ref="chhoseaccout" @closedialog="closedialog" @closedialogone="closedialogone" />
    </el-dialog>
    <el-dialog
      title="选择绑定的小程序"
      :visible.sync="dialogVisiblewechat"
      :close-on-click-modal="false"
      width="30%"
    >
      <chhosewechat ref="chhosewecahtr" @callback="callback" />
    </el-dialog>
    <el-dialog
      title="绑定公众号失败原因"
      :visible.sync="errordialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @close="dajwe"
    >
      <errorbind ref="errordialogview" />
    </el-dialog>
    <el-dialog
      title="解绑"
      :visible.sync="dialogVisiblenowechat"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="80%"
    >
      <piliangnoband ref="piliangnobandview" @unbandaccount="unbandaccount" />
    </el-dialog>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import ChooseaccountDialog from './components/ChooseaccountDialog.vue'
import chhosewechat from './components/chhosewechat.vue'
import errorbind from '../officialAccountMerchant/components/errorbind.vue'
import piliangnoband from './components/piliangnoband.vue'
import { publicapplication, publicwechatlist, accountunbind, accountrestore, accountrefresh, exportexcleall, officialAccountunbindByMpAppid } from '@/api/sourceMaterial.js'
export default {
  components: {
    PaginationRight,
    ChooseaccountDialog,
    chhosewechat,
    errorbind,
    piliangnoband
  },
  data() {
    return {
      tableData: [],
      total: null,
      dialogVisible: false,
      dialogVisibler: false,
      dialogVisiblewechat: false,
      pageIfon: {
        page: 1,
        pageSize: 10,
        ofword: null,
        mpword: null,
        onlyMe: 2,
        status: null
      },
      arrs: [],
      wechatid: null,
      wechatname: '',
      arrsw: [],
      errordialog: false,
      accountarr: [{
        value: 1,
        label: '查看组内公众号'
      }, {
        value: 2,
        label: '我关联的公众号'
      }],
      statusarr: [{
        value: 1,
        label: '等待处理'
      }, {
        value: 2,
        label: '已经处理'
      }, {
        value: 3,
        label: '解绑'
      }, {
        value: 4,
        label: '绑定失败'
      }],
      dialogVisiblenowechat: false,
      unarr: []
    }
  },
  created() {
    this.wecharselist()
  },
  mounted() {

  },
  methods: {
    // 公众号绑定小程序列表
    async wecharselist() {
      const data = await publicwechatlist(this.pageIfon)
      this.tableData = data.data.list
      this.total = data.data.count
      console.log('data', data)
    },
    search() {
      this.wecharselist()
    },
    reset() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.pageIfon.ofword = null
      this.pageIfon.mpword = null
      this.pageIfon.onlyMe = 2
      this.pageIfon.status = null
      this.wecharselist()
    },
    exportexcle() {
      this.$confirm('确定要导出吗？ 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        exportexcleall({
          ofword: this.pageIfon.ofword,
          mpword: this.pageIfon.mpword,
          onlyMe: this.pageIfon.onlyMe,
          status: this.pageIfon.status }).then((res) => {
          console.log('res', res)
          if (res.data.url === '') {
            console.log('空')
          } else {
            this.$message({
              type: 'success',
              message: '导出成功!'
            })
            window.open(res.data.url, '_blank')
          }
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 点击绑定小程序
    bandwechatar() {
      this.dialogVisible = true
    },
    chooseaccout() {
      this.dialogVisibler = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.sendrs(this.arrs)
      }, 100)
    },
    rightclick(id, index) {
      this.arrs.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.set(id)
      }, 100)

      console.log(id, index)
    },
    closedialog(arr) {
      this.arrs = arr
      this.dialogVisibler = false
      console.log('arr', arr)
    },
    closedialogone(arr) {
      this.arrs = arr
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.wecharselist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.wecharselist()
    },
    closewechat() {
      this.arrs = []
      this.wechatname = ''
      this.wechatid = null
      if (this.$refs.chhoseaccout) {
        this.$nextTick(() => {
          this.$refs.chhoseaccout.reast()
        })
      }
    },
    choosewecaht() {
      this.dialogVisiblewechat = true
      this.$nextTick(() => {
        this.$refs.chhosewecahtr.send()
      })
    },
    callback(item) {
      this.dialogVisiblewechat = false
      this.wechatname = item.account_name
      this.wechatid = item.app_id
      console.log('item', item)
    },
    async sureonclick() {
      this.arrsw = this.arrs.map(item => {
        return item.id
      })
      // if (this.wechatid === null) {
      //   this.$message.error('请选择绑定小程序')
      //   return
      // }
      if (this.arrsw.length === 0) {
        this.$message.error('请选择公众号')
        return
      }
      if (this.wechatid === null) {
        accountrefresh({
          app_ids: this.arrsw
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '刷新成功'
          })
        })
      } else {
        const data = await publicapplication({
          appIds: this.arrsw,
          miniProgramAppId: this.wechatid
        })
        console.log('data2222222222', data.data.failList)
        // eslint-disable-next-line eqeqeq
        if (data.data.failList.length !== 0) {
          this.errordialog = true
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.errordialogview.send(data.data.failList)
          }, 100)
        } else {
          this.$message({
            type: 'success',
            message: '新增成功'
          })
        }
      }

      // eslint-disable-next-line eqeqeq
      // if (data.data.failed == '') {
      //   this.$message({
      //     message: '新增成功',
      //     type: 'success'
      //   })
      // } else {
      //   this.$message({
      //     message: `绑定失败的公众号：${data.data.failed}`,
      //     type: 'error'
      //   })
      // }

      this.dialogVisible = false
      this.arrs = []
      this.arrsw = []
      this.wechatname = ''
      this.wechatid = null
      this.wecharselist()
    },
    dajwe() {
      // this.wecharselist()
    },
    unbind(item) {
      console.log(item)
      this.$confirm('确定要解绑吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        accountunbind({
          id: item.id
        }).then((res) => {
          this.$message({
            message: '解绑成功',
            type: 'success'
          })
          this.wecharselist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    restore(item) {
      console.log('restore item', item)
      this.$confirm('确定要恢复吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        accountrestore({
          id: item.id,
          type: 2
        }).then((res) => {
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.wecharselist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    refresh(item) {
      console.log(item)
      this.$confirm('确定要刷新吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        accountrefresh({
          id: item.id
        }).then((res) => {
          this.$message({
            message: '刷新成功',
            type: 'success'
          })
          this.wecharselist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    pijie() {
      this.dialogVisiblenowechat = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.piliangnobandview.send()
      }, 100)
    },
    async unbandaccount(appid) {
      this.dialogVisiblenowechat = false
      const data = await officialAccountunbindByMpAppid({
        miniprogram_app_id: appid
      })
      this.$message({
        message: `${data.message}`,
        type: 'success'
      })
      this.wecharselist()
      console.log(data)
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.dsawr{
  padding: 20px;
}
.strate_box{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  div{
    flex-shrink: 0;
    font-size: 14px;
    color: #606266;
  }
   span{
      margin-left: 10px;
   }
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
.search_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>
